import React, { useState } from 'react';
import CustomSideNav from './CustomSideNav';
import useSideNavStore from '../Zustand/Zustandstore';
const SideNavLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const isSidenav = useSideNavStore((state) => state.isSidenav);
  // Define the margin based on the collapsed state
  // const marginLeftClass = isCollapsed ? 'ml-[20%] sm:ml-[4%]' : '';
if(!isSidenav){
  return children
}
  return (
    <div className="flex">
      <CustomSideNav isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} /> {/* Sidebar Component */}
      <div className={`flex-grow p-2 bg-gray-100 `}>
        {/* The children prop will hold the main content */}
        {children}
      </div>
    </div>
  );
};

export default SideNavLayout;
